<!--
  - Placeholder label.
-->
<label
    *ngIf="!displayAsText && !displayAsTag && !lmParagraphLayoutInfo"
    [ngClass]="{'label lm-placeholder-label no-colon' : true, 'lm-no-label': lmColumnLayoutInfo?.isTable}"
>&nbsp;</label>
<div
  [ngClass]="{'disabled-member-field': disabledMemberField, 'lm-checkbox-field-options': true}"
  lm-field-options
    [hasContextMenu]="insertContextMenu"
    [isMemberField]="isCompoundFieldMember"
    [dataEntryMode]="dataEntryMode"
    [isCheckBoxField]="true"
    [ajaxCallbackFunction]="onBeforeContextMenuOpen"
    [contextMenuEventFunction]="contextMenuClicked"
    [buttonId]="fieldOptionsId"
    [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
    [isInAccessibilityMode]="isInAccessibilityMode"
    [displayFieldOptions]="displayFieldOptions"
    [fieldAutomationId]="fieldAutomationId"
  soho-tooltip
    [popover]="true"
    [title]="popoverTitle"
    [placement]="'right'"
    [trigger]="'click'"
  (click)="onCompoundFieldClickEvent($event)"
  (focus)="onFocus($event)"
  (contextmenu)="onContextMenu($event)"
  (focusin)="onFieldFocus($event)"
  (focusout)="onFieldBlur($event)">
  <ng-container [ngSwitch]="displayType">
    <ng-container *ngSwitchCase="layoutDisplayType.PLAIN">
      <span *ngIf="showDirtyCheckboxIndicator" class="icon-dirty lm-compound-member-field-dirty"></span>
      <input
        type="checkbox"
        [ngClass]="fieldClassesString"
        [attr.id]="id"
        [attr.bindId]="bindId"
        [readOnly]="(readOnly$ | async) ? true : null"
        [disabled]="(readOnly$ | async) ? true : null"
        [attr.tabindex]="isInAccessibilityMode && !isPreviewCompoundMember ? 0 : null"
        [attr.aria-describedby]="(required$ | async) ? fieldDescriptionId : null"
        [(ngModel)]="modelField.value"
        soho-checkbox
        soho-alert
        soho-trackdirty
          (dirty)="onDirty($event)"
          (pristine)="onPristine($event)"
          (afterResetDirty)="onAfterResetDirty($event)"
        soho-input-validate
          (error)="onError($event)"
          (valid)="onValid($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
      />
      <label
        class='lm-checkbox-label'
        [attr.for]="id"
        [attr.tabindex]="(isInAccessibilityMode && readOnly$ | async) ? 0 : null"
        soho-label
          [forCheckBox]=true
          [required]="required$ | async"
        lm-label
          [layoutField]="field"
          [personalize]="personalize"
        lm-text-style
          [textStyle]="field?.label?.textStyle"
      >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
      </label>
      <span [class.required]="isRequired" aria-hidden="true"></span>
    </ng-container>
    <ng-container *ngSwitchCase="layoutDisplayType.SWITCH">
      <div
        class="switch"
        [ngStyle]="{'display': 'inline-block'}"
        soho-tooltip
          content="{{triggerValueChange | async | booleanAsSwitchTooltip:modelField.value:isReadOnly}}"
      >
        <input
          type="checkbox"
          [ngClass]="fieldClassesString"
          [attr.id]="id"
          [attr.bindId]="bindId"
          [readOnly]="(readOnly$ | async) ? true : null"
          [disabled]="(readOnly$ | async) ? true : null"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          [(ngModel)]="modelField.value"
          soho-alert
          soho-trackdirty
            (dirty)="onDirty($event)"
            (pristine)="onPristine($event)"
            (afterResetDirty)="onAfterResetDirty($event)"
          soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
        />
        <label
          class='lm-checkbox-label'
          [attr.for]="id"
          [attr.tabindex]="(isInAccessibilityMode && readOnly$ | async) ? 0 : null"
          soho-label
            [required]="required$ | async"
          lm-label
            [layoutField] = "field"
            [personalize]="personalize"
          lm-text-style
            [textStyle]="field?.label?.textStyle"
        >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
        </label>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TAG">
      <label
          class='lm-checkbox-label display-as-text-label'

          attr.for="{{id}}"
          soho-label
          lm-label
            [layoutField] = "field"
            [checkBoxIsDisplayAsText]="true"
            [displayInlineBlock]="isCompoundFieldMember"
          lm-text-style
            [textStyle]="field?.label?.textStyle"
      >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
      </label>

      <span class="tag is-dismissible"
          attr.id="{{id}}"
          [ngStyle]="{'color': '#FFFFFF', 'outline': 'none'}"
          [ngClass]="{
            'lm-compound-text': isCompoundFieldMember,
            'lm-text-data ': !isCompoundFieldMember,
            'is-active': isFieldTagFocused,
            'is-focused': isFieldTagFocused,
            'hide-focus': !isFieldTagFocused
           }"
          soho-alert
          lm-field-style [fieldStyle]="tagStyle?.style" [isTag]="true" [recalculateStyles]="triggerValueChange | async"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          (focus)="onTagFocus()"
          (blur)="onTagBlur()"
      >{{triggerValueChange | async | booleanAsText:modelField.value}}</span>
    </ng-container>

  <ng-container *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TEXT">
      <label
          class='lm-checkbox-label display-as-text-label'
          attr.for="{{id}}"
          soho-label
          lm-label
            [layoutField]="field"
            [checkBoxIsDisplayAsText]="true"
            [displayInlineBlock]="isCompoundFieldMember"
            [personalize]="personalize"
          lm-text-style
            [textStyle]="field?.label?.textStyle"
      >{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
      </label>
      <p class="hide-white-space"
          attr.id="{{id}}"
          [attr.tabindex]="isInAccessibilityMode && !isPreviewCompoundMember ? 0 : null"
          [ngClass]="{'lm-compound-text': lmParagraphLayoutInfo?.previewMode, 'lm-text-data ': !lmParagraphLayoutInfo?.previewMode}"
          [ngStyle]="{'display': 'inline-block'}"
          soho-alert
          lm-field-style
            [fieldStyle]="field?.fieldStyle"
            [recalculateStyles]="triggerValueChange | async"
          [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
      >{{triggerValueChange | async | booleanAsText:modelField.value}}</p>
    </ng-container>
  </ng-container>
</div>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
<span [id]="fieldDescriptionId" class="audible">{{ (required$ | async) ? ('Required' | translate) : '' }}</span>
